const numberAnimation = {
    init() {



        let lastKnownScrollPosition = 0;
        let ticking = false;

        function doSomething(scrollPos) {

            if($('.my-progress-bar')[0]){
                let isInView = $('.my-progress-bar').inView('both');
            }

            $('.stats-block__holder').each(function(index, el){
                let isInView = $(this).inView('both');
                console.log(isInView)


            });


            // Do something with the scroll position


        }

        document.addEventListener('scroll', (e) => {
            lastKnownScrollPosition = window.scrollY;

            if (!ticking) {
                window.requestAnimationFrame(() => {
                    doSomething(lastKnownScrollPosition);
                    ticking = false;
                });

                ticking = true;
            }
        });

    }
}
export {numberAnimation}